import { ColumnDef } from "@tanstack/react-table";
import React from "react";
import { Album } from "../../api/useMusicApi";
import { TableRenderUtils } from "../../components/Table/TableRenderUtils";
import { truncate } from "../../utils";
import { InputCheckbox } from "../../components/InputCheckbox";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic } from "@fortawesome/free-solid-svg-icons/faMusic";
import { faVideo } from "@fortawesome/free-solid-svg-icons/faVideo";

export function albumsColumnsDefinition(
  t: any,
  contentType: string
): Array<ColumnDef<Album, any>> {
  return [
    {
      id: "select",
      size: 10,
      enableSorting: false,
      header: ({ table }) =>
        TableRenderUtils.renderBaseContent(
          <InputCheckbox
            checked={table.getIsAllRowsSelected()}
            onChange={(value, e) => {
              table.getToggleAllRowsSelectedHandler()(e);
            }}
          />
        ),
      cell: ({ row }) => (
        <InputCheckbox
          {...{
            checked: row.getIsSelected(),
            disabled: !row.getCanSelect(),
            indeterminate: row.getIsSomeSelected(),
            onChange: row.getToggleSelectedHandler()
          }}
        />
      )
    },
    {
      id: "Image",
      header: "",
      size: 100,
      enableSorting: false,
      accessorFn: (value) => value.image_url_template,
      cell: (value) => {
        const url = value.getValue()
          ? value.getValue().replace("{}", "medium")
          : "/album_cover_default_150x150.jpg";
        return TableRenderUtils.renderBaseContent(
          <img
            height={50}
            width={50}
            className={"border rounded"}
            src={url}
            alt={"album_preview"}
          />
        );
      }
    },
    {
      id: "Title",
      header: `${t("name")}`,
      size: 300,
      enableSorting: false,
      accessorFn: (value) => value.country_meta,
      cell: (value) => {
        let content = null;
        if (
          value.row.original.country_meta == null ||
          value.row.original.country_meta.title == null
        ) {
          content = "--";
        } else {
          content = (
            <Link
              to={`/music/albums/${value.row.original.id}`}
              className={"dark:text-white"}
            >
              {value.row.original.country_meta.title.ALL}{" "}
              {value.row.original?.country_meta?.subtitle?.ALL != null && (
                <>({value.row.original.country_meta.subtitle.ALL})</>
              )}
            </Link>
          );
        }

        return TableRenderUtils.renderBaseContent(content);
      }
    },
    {
      id: "Artist",
      header: `${t("artist")}`,
      size: 600,
      enableSorting: false,
      accessorFn: (value) => value.country_meta,
      cell: (value) => {
        let content = null;
        if (
          value.row.original.country_meta == null ||
          value.row.original.country_meta.artists == null
        ) {
          content = "--";
        } else {
          content = (
            <>
              {truncate(
                value.row.original.country_meta.artists.main
                  .map((t) => t.ALL)
                  .join(", "),
                80
              )}{" "}
              <span className={"text-gray-400"}>
                {value.row.original.country_meta.artists.featured
                  .map((t) => t.ALL)
                  .join(", ")}
              </span>
            </>
          );
        }
        return TableRenderUtils.renderBaseContent(content);
      }
    },
    {
      id: "CodeICPN",
      header: `${t("ups")}`,
      enableSorting: false,
      accessorFn: (value) => value.code_icpn ?? "–",
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue());
      }
    },
    {
      id: "TracksCount",
      header: `${t("tracks_count")}`,
      enableSorting: false,
      accessorFn: (value) => value.tracks_count ?? "–",
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue());
      }
    },
    {
      id: "icon",
      header: `${t("content_type")}`,
      enableSorting: false,
      accessorFn: (value) => value.content_type,
      cell: (value) => {
        const icon = contentType === "audio" ? faMusic : faVideo;
        return TableRenderUtils.renderBaseContent(
          <FontAwesomeIcon icon={icon} size={"lg"} />,
          { className: "text-center" }
        );
      }
    }
  ];
}
